export default __webpack_public_path__ + "static/media/Copy of Pose2.23441f46.mp4";